export default {
  meta: {
    title: '企业配置',
    url: '/system/enterprise', // 埋点用，记录所属模块
  },
};
